'use client';

import { workspaceAccessConfig } from '@/config/workspace-access';

import { usePaidAccess } from '@/hooks/payment/use-payment';

export function useWorkspacePaidAccessState(userId: string | null) {
  const { data } = usePaidAccess(userId ?? undefined);
  const hasPaidAccess = Boolean(data?.hasPaidAccess);

  return {
    hasPaidAccess,
    showPaidFeatureMarkers:
      workspaceAccessConfig.paidEntitlementsEnabled && !hasPaidAccess,
  };
}
